import { render } from "./ContactWarning.vue?vue&type=template&id=f17a565c&scoped=true"
import script from "./ContactWarning.vue?vue&type=script&lang=js"
export * from "./ContactWarning.vue?vue&type=script&lang=js"

import "./ContactWarning.vue?vue&type=style&index=0&id=f17a565c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f17a565c"]])

export default __exports__